import { roomDetails } from '@/constants/rooms'
import { serviceItems } from '@/constants/services'
import { packageItems } from '@/constants/packages'
import { articles } from '@/constants/articles'
import { contactDetails } from '@/constants/site'

export type Testimonial = { name: string, avatar: string, quote: string }
export type LocationMedia = { type: 'image' | 'video', src: string, alt: string }

/** Cards link to /stay/[slug], so they read from the same records as the detail pages. */
export const rooms = roomDetails.map((room) => ({
    slug: room.slug,
    name: room.name,
    size: room.size,
    bed: room.bed,
    image: room.cardImage,
    alt: room.imageAlts.card,
    description: room.cardDescription
}))

export const services = serviceItems.slice(0, 4).map((item) => ({
    index: item.index,
    title: item.title,
    tags: item.chips,
    image: item.image,
    alt: item.alt,
    description: item.description
}))

/** Distances as stated on the original's "Where" page. */
export const locationStats: { value: string, lines: string[], media: LocationMedia }[] = [
    {
        value: '04',
        lines: ['miles north of', 'Washburn, Wisconsin'],
        media: { type: 'image', src: '/images/lake-superior-shoreline.jpg', alt: 'Sand and stone beach below the wooded bluff on Lake Superior' }
    },
    {
        value: '09',
        lines: ['miles south of', 'Bayfield, Wisconsin'],
        media: { type: 'image', src: '/images/boathouse-full-moon.jpg', alt: "The Bodin's boathouse under a full moon over the water" }
    },
    {
        value: '13',
        lines: ['on the Lake Superior', 'Scenic Byway of Highway 13'],
        media: { type: 'image', src: '/images/brownstone-quarry.jpg', alt: 'The Brownstone Quarry reflecting the surrounding forest' }
    }
]

export const packages = packageItems.slice(0, 2)

/** Only real, attributable reviews belong here. The section hides itself while this is empty. */
export const testimonials: Testimonial[] = []

export const guestAvatars: string[] = []

export const partnerLogos: string[] = []

/** Overall guest rating shown beside the reviews heading. Leave null unless it is real. */
export const guestRating: { score: string, label: string } | null = null

/** `rotate` is the tile's starting angle: it pops from scale(0.2) at that
 *  angle and settles upright, exactly as the original does. Captions are the
 *  original gallery's own. */
export const galleryStrip = [
    { image: '/images/painted-outhouse.jpg', caption: 'We provide a few other amenities as well!', alt: 'A hand painted outhouse among the trees', rotate: -5 },
    { image: '/images/woods-path.jpg', caption: 'Walk through the woods to the other beaches.', alt: 'A footpath through the pines toward the lake', rotate: 0 },
    { image: '/images/white-cottage.jpg', caption: 'White Cottage', alt: 'The White Cottage and its deck on the lawn', rotate: 5 },
    { image: '/images/red-cabin-anchor.jpg', caption: "A red anchor and red cedar mulch are your signs you've reached the Red Cabin.", alt: 'A red anchor set in driftwood beside the Red Cabin', rotate: -2 },
    { image: '/images/red-cabin-living-room.jpg', caption: 'Comfortable surroundings with great views of the lake.', alt: 'Red Cabin living room with armchairs and a red rug', rotate: 1 }
]

export const newsPosts = articles.slice(0, 3).map((article) => ({
    slug: article.slug,
    category: article.category,
    title: article.title,
    date: article.date,
    image: article.image,
    alt: article.imageAlt
}))

export const chooseTiles = [
    {
        eyebrow: 'Choose your',
        title: 'Cabin',
        href: '/#rooms',
        image: '/images/gray-cabin-bedroom-lake-view.jpg',
        alt: 'A Gray Cabin bedroom window looking out to Lake Superior'
    },
    {
        eyebrow: 'Check',
        title: 'Availability',
        href: contactDetails.availabilityUrl,
        image: '/images/quarry-reflections.jpg',
        alt: 'Pines reflected in the still water of the Brownstone Quarry'
    }
]
